export const Fingers = {
    LEFT_LITTLE : 'LEFT_LITTLE',
    LEFT_RING: 'LEFT_RING',
    LEFT_MIDDLE: 'LEFT_MIDDLE',
    LEFT_INDEX: 'LEFT_INDEX',
    LEFT_THUMB: 'LEFT_THUMB',
    RIGHT_THUMB: 'RIGHT_THUMB',
    RIGHT_INDEX: 'RIGHT_INDEX',
    RIGHT_MIDDLE: 'RIGHT_MIDDLE',
    RIGHT_RING: 'RIGHT_RING',
    RIGHT_LITTLE: 'RIGHT_LITTLE',
    UNKNOWN:'UNKNOWN'
}

export const FingerIndex = {
    NOT_SELECTED_OR_FACE: 0,
    LEFT_LITTLE: 1,
    LEFT_RING: 2,
    LEFT_MIDDLE: 3,
    LEFT_INDEX: 4,
    LEFT_THUMB: 5,
    RIGHT_THUMB: 6,
    RIGHT_INDEX: 7,
    RIGHT_MIDDLE: 8,
    RIGHT_RING: 9,
    RIGHT_LITTLE: 10,
}
